import PropTypes from "prop-types"
import { connect } from "react-redux"
import { get } from 'lodash'

// #WARNING esta función tiene todas las papeletas para acabar duplicada
// #NOTE la publicamos porque en algunos sitios no se puede fácilmente usar 
// el componente (e.g. entre un NavItem y su Nav)
export function can(userPermissions, verb, collection) {
  return get(userPermissions, [collection, verb], false)
}

function IfAllowed(props) {
  return (
    props.userPermissions && can(props.userPermissions, props.verb, props.collection)
      ? props.children
      : props.else
  )
}

IfAllowed.propTypes = {
  collection: PropTypes.string.isRequired,
  verb: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  else: PropTypes.node,
  
  userPermissions: PropTypes.object,  
}

IfAllowed.defaultProps = {
  else: null,
  userPermissions: null
}

function mapStateToProps(state, _ownProps) {
  return {
    userPermissions: state.permissions.userPermissions
  }
}

export default connect(mapStateToProps)(IfAllowed)